"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateRestrictions = exports.getRestrictions = void 0;
var core_1 = __importDefault(require("@gin-betting/core"));
var constants_1 = require("./constants");
var makeAction = core_1.default.utils.makeAction;
var getRestrictions = function (variables, args) {
    return {
        type: constants_1.GET_RESTRICTION_REQUEST,
        payload: {
            method: 'getRestrictions',
            variables: variables,
            args: args,
        },
        meta: {
            isApiCall: true,
        },
    };
};
exports.getRestrictions = getRestrictions;
var updateRestrictions = function (_a) {
    var restrictions = _a.restrictions, betslipOddIds = _a.betslipOddIds;
    return makeAction(constants_1.UPDATE_RESTRICTIONS, {
        data: { restrictions: restrictions },
        betslipOddIds: betslipOddIds,
    });
};
exports.updateRestrictions = updateRestrictions;
//# sourceMappingURL=actions.js.map